/** The one composition every v2 render uses (#77). JSX-free for the server. */
export const TIMELINE_COMPOSITION_ID = 'timeline'
